import { useBorneStore } from './store/borne-store'
import { useConfigStore } from './store/config-store'
import { useAuthStore } from './store/auth-store'
import { useAuthRefresh } from './hooks/useAuthRefresh'
import { BlockedOverlay } from './components/BlockedOverlay'
import { Toast } from './components/Toast'
import { LoginScreen } from './screens/LoginScreen'
import { SetupScreen } from './screens/SetupScreen'
import { ScreensaverScreen } from './screens/ScreensaverScreen'
import { ProductsScreen } from './screens/ProductsScreen'
import { PaymentScreen } from './screens/PaymentScreen'
import { AdminScreen } from './screens/AdminScreen'

export default function App() {
  const screen = useBorneStore((s) => s.screen)
  const connectionStatus = useBorneStore((s) => s.connectionStatus)
  const isConfigured = useConfigStore((s) => s.isConfigured)
  const isAuthenticated = useAuthStore((s) => s._isAuthenticated)

  useAuthRefresh()

  const activeScreen = !isAuthenticated
    ? 'login'
    : !isConfigured
      ? 'setup'
      : screen

  return (
    <div className="h-full w-full bg-surface relative">
      {activeScreen === 'login' && <LoginScreen />}
      {activeScreen === 'setup' && <SetupScreen />}
      {activeScreen === 'screensaver' && <ScreensaverScreen />}
      {activeScreen === 'products' && <ProductsScreen />}
      {activeScreen === 'payment' && <PaymentScreen />}
      {activeScreen === 'admin' && <AdminScreen />}

      {connectionStatus === 'blocked' && <BlockedOverlay />}
      <Toast />
    </div>
  )
}
